import Client from './client';

export default class FraudReviewDecisions extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/reviews/${id}/decision`, {
      ...options,
       method: 'POST',
    });
  }

}
